import { isFunction } from 'underscore';
import { useCallback, useMemo, useState } from 'react';

export const useNeedsAttention = (attentionBeaconPropsFromProps) => {
  const [needsAttention, setNeedsAttention] = useState(false);
  const { onNeedsAttentionChange: onNeedsAttentionChangeFromProps } = attentionBeaconPropsFromProps;
  const onNeedsAttentionChange = useCallback((newNeedsAttention) => {
    if (isFunction(onNeedsAttentionChangeFromProps)) {
      onNeedsAttentionChangeFromProps(newNeedsAttention);
    }
    setNeedsAttention(newNeedsAttention);
  }, [onNeedsAttentionChangeFromProps]);

  const attentionBeaconProps = useMemo(() => ({
    ...attentionBeaconPropsFromProps,
    onNeedsAttentionChange,
  }), [attentionBeaconPropsFromProps, onNeedsAttentionChange]);

  return [needsAttention, attentionBeaconProps];
};
